export * from './keys';
export const DESCRIPTION = 'Description';
export const ERROR = 'Error';
export const FILE = 'File';
export const GROUP = 'Group';
export const HINT = 'Hint';
export const INPUT = 'Input';
export const LABEL = 'Label';
export const TEXTAREA = 'Textarea';
export const TITLE = 'Title';
//# sourceMappingURL=index.js.map